function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const costImportsApi = buildService('/claims/{id}/claim_template_unmapped_imports', {
  only: ['all']
});
const projectImportsApi = buildService('/claim_groups/{id}/project_template_unmapped_imports', {
  only: ['all']
});
const claimTemplateImportsService = {
  useFetchAll: (setLoading, claimId, claimGroupId) => {
    const [imports, setImports, fetchImports] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimId || !claimGroupId) return [];
        const [costImports, projectImports] = await Promise.all([costImportsApi.all(claimId), projectImportsApi.all(claimGroupId)]);
        const cost = (Array.isArray(costImports) ? costImports : []).filter(i => i.import_status !== 'never_imported').map(i => _objectSpread(_objectSpread({}, i), {}, {
          import_type: 'cost'
        }));
        const project = (Array.isArray(projectImports) ? projectImports : []).filter(i => i.import_status !== 'never_imported').map(i => _objectSpread(_objectSpread({}, i), {}, {
          import_type: 'project'
        }));
        return [...cost, ...project].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      }, [claimId, claimGroupId]),
      setLoading,
      initialStateValue: []
    });
    return [imports, setImports, fetchImports];
  },
  usePolling: function (imports, fetchImports) {
    let enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const hasPendingImports = imports.some(imp => imp.import_status === 'pending');
    serviceMethods.usePolling({
      callback: fetchImports,
      enabled: enabled && hasPendingImports,
      intervalMs: 7000
    });
  }
};
claimTemplateImportsService.useCrud = (setLoading, claimId, claimGroupId) => {
  const [imports, setImports, fetchImports] = claimTemplateImportsService.useFetchAll(setLoading, claimId, claimGroupId);
  claimTemplateImportsService.usePolling(imports, fetchImports, true);
  return {
    imports,
    setImports,
    fetchImports
  };
};
export default claimTemplateImportsService;